export default "__VITE_ASSET__BE6riEpJ__"